"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var event_1 = require("./event");
var TIMING_KEYS = ["", "fetchStart", "domainLookupStart", "domainLookupEnd", "connectStart", "connectEnd", "requestStart", "responseStart", "responseEnd", "", "domInteractive", "", "domContentLoadedEventEnd", "", "loadEventStart", "", "msFirstPaint", "secureConnectionStart"];
function browserPer(tracker) {
    // 页面已绑定的onerror事件
    var win = window;
    var onErrorHandler = win.onerror;
    var browser = {
        /**
         * 初始化浏览器端调用
         *
         * @return {void}
         */
        init: function () {
            this.sendPerformance();
            // this.bind(); 默认不绑定
        },
        /**
         * 获取performance性能数据
         *
         * @returns {{}}
         */
        analyzeTiming: function () {
            // performance初始数据
            var performanceData = {};
            // const datas = {
            //     "rrt": ["responseStart", "requestStart"], // 整个网络请求时间（不包括unload）
            //     "dns": ["domainLookupEnd", "domainLookupStart"], // dns lookup
            //     "cnt": ["connectEnd", "connectStart"], // 建立 tcp 时间 /tcp
            //     "ntw": ["responseStart", "fetchStart"], // network time / ttfb
            //     "dct": ["domContentLoadedEventStart", "fetchStart"], // dom content loaded time
            //     "flt": ["loadEventStart", "fetchStart"] // full load time 页面完全加载时间 /load
            //     // "flv": this._getFlashVersion(),
            // };
            // 文档 https://yuque.antfin-inc.com/retcode/arms-retcode/keywords
            var datas = {
                dns: [3, 2],
                rrt: [8, 7],
                cnt: [5, 4],
                ntw: [7, 6],
                dct: [12, 1],
                flt: [14, 1],
                ssl: [5, 17],
                dom: [10, 8],
                res: [14, 12],
                firstbyte: [7, 2],
                fpt: [8, 1],
                tti: [10, 1],
            };
            try {
                var timing = performance.timing;
                for (var name_1 in datas) {
                    var arr = datas[name_1];
                    var start = timing[TIMING_KEYS[arr[1]]];
                    var end = timing[TIMING_KEYS[arr[0]]];
                    // 脏数据过滤: 部分浏览器,特别是移动端(如UC,windvane容器)某些时间点可能返回0或者null,排除掉此部分
                    if (start && end) {
                        var cost = end - start;
                        // 脏数据过滤: 耗时大于0并且小于1天(1e3 * 3600 * 24)
                        if (cost >= 0 && cost < 86400000) {
                            performanceData[name_1] = cost;
                        }
                    }
                }
                var navigator_1 = win.navigator, connection = navigator_1.connection;
                /**
                 * 获取网络连接类型 connection effectiveType
                 * 例：slow-2g/2g/3g/4g
                 * 目前只在 chrome 中能拿到数据
                 */
                performanceData.ct = connection ? connection.effectiveType || connection.type : '';
            }
            catch (e) {
                // console.log('error');
            }
            return performanceData;
        },
        /**
         * 上报performance性能数据
         */
        sendPerformance: function () {
            // support log.js async loaded
            if (document.readyState === 'complete') {
                tracker.log('per', browser.analyzeTiming());
            }
            else {
                event_1.default.on(win, 'load', function () {
                    tracker.log('per', browser.analyzeTiming());
                }, true);
            }
        }
    };
    browser.init();
    return browser;
}
exports.default = browserPer;
//# sourceMappingURL=browser-performance.js.map